/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.initInvitation = function() {
  initAnonymousFields();
  return initMoreInvitationOptions();
};

root.anonymousClick  = function(anonymous, message) {
  const checked = anonymous.prop('checked');
  if (checked === true) {
    message.prop('disabled', true);
    return message.val(' ');
  } else {
    message.prop('disabled', false);
    return message.val('');
  }
};

root.initAnonymousFields = () => $("input[name$='[anonymous]']").each(function(index) {
  return initAnonymousField(this);
});

root.initMoreInvitationOptions = function() {
  const form = $('#new_invitation');
  return $(form).foundation();
};

root.initAnonymousField = function(field) {
  const $el = $(field);
  const $form = $el.parents('form');
  const $message = $form.find("textarea[name$='[message]']");
  if ($message) {
    return $el.click(() => anonymousClick($el, $message));
  }
};

root.initAutofocus = function(container) {
  container.find('input[autofocus]:first').focus();
} 

/*
$(function() {
  if ($("input[name$='[anonymous]']").length) {
    return initAnonymousFields();
  }
});
*/

function initInvitationOnLoad() {
  if ($("input[name$='[anonymous]']").length) {
    initAnonymousFields();
  }
  //if ($('#new_invitation').length) {
  //  initMoreInvitationOptions();
  //}
  //if ($('input[autofocus]:first').length) {
  //  initAutofocus();
  //}
}

$(initInvitationOnLoad);
document.addEventListener('turbo:load', initInvitationOnLoad);
